module.exports = __webpack_public_path__ + "static/media/  (65).79204c40.jpg";